import React, { useState } from "react";
import shareit from "../../../../assets/contact-share.png";
import facebook from "../../../../assets/contact-facebook.png";
import youtube from "../../../../assets/contact--youtube.png";
import linkedin from "../../../../assets/contact--linkedin.png";
import jiotune from "../../../../assets/contact-jiotune.png";
import instagram from "../../../../assets/contact-instagram.png";
import Watsapp from "../../../../assets/contact-watsapp.png";
import rightuparrow from "../../../../assets/right-up-arrow.png";
import GlowButton from "../../GlowButton";

const ContactContent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    jobTitle: "",
    businessName: "",
    businessAddress: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/zoho/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error("submission failed");
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { event_category: 'contact', event_label: 'contact_form' });
      }
      setSubmitted(true);
    } catch {
      setError("something went wrong. please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-start bg-white text-gray-800 px-6 sm:px-10 md:px-17 py-20 sm:py-28 md:py-36 font-poppins">
      {/* Left Section */}
      <div className="flex-1 md:mr-8 mb-10 md:mb-0 mt-10 sm:mt-20 md:mt-[130px] w-full">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-lexend font-semibold mb-3 sm:mb-4 lowercase">
          <span className="text-[#DB8B11]">let’s connect</span> and
        </h2>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-lexend font-semibold mb-4 lowercase">
          make things happen
        </h2>

        <p className="text-gray-600 mb-8 max-w-md mt-6 sm:mt-[35px] text-sm sm:text-base lowercase">
          Have a question or need support? We’re here to help. Reach out to our
          team anytime and we’ll get back to you quickly.
        </p>

        {/* Social Icons */}
        {/* <div className="flex flex-wrap items-center space-x-3 sm:space-x-4 mt-8 sm:mt-[50px]">
          <h2 className="font-bold pt-2 pb-2 text-lg sm:text-xl md:text-2xl mb-2 sm:mb-0">
            follow us <span className="ml-1 sm:ml-2">:</span>
          </h2> */}

          {/* Social links */}
          {/* {[
            { img: shareit, alt: "Share It" },
            { img: facebook, alt: "Facebook" },
            { img: youtube, alt: "YouTube" },
            { img: linkedin, alt: "LinkedIn" },
            { img: jiotune, alt: "JioTune" },
            { img: instagram, alt: "Instagram" },
            { img: Watsapp, alt: "WhatsApp" },
          ].map((icon, index) => (
            <a
              key={index}
              href="https://play.google.com/store/apps/details?id=com.beemxyz&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={icon.img}
                alt={icon.alt}
                className="h-8 sm:h-10 md:h-11 cursor-pointer hover:scale-105 transition-transform duration-300"
              />
            </a>
          ))}
        </div> */}
      </div>

      {/* Right Section */}
      <div className="flex-1 bg-white rounded-2xl p-6 sm:p-8 md:p-10 shadow-2xl w-full">
        {submitted ? (
          <div className="flex flex-col items-center justify-center py-16 text-center gap-4">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#e9d9ff]">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-[#6E3FC6]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h3 className="text-2xl font-lexend font-bold text-black">thank you!</h3>
            <p className="text-gray-500 font-poppins text-sm sm:text-base max-w-sm">
              we've received your message and will be in touch within 3 to 5 working days.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
            <input
              type="text"
              name="name"
              placeholder="name*"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <input
              type="email"
              name="email"
              placeholder="email*"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <input
              type="tel"
              name="phone"
              placeholder="phone number*"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <input
              type="text"
              name="jobTitle"
              placeholder="job title (optional)"
              value={formData.jobTitle}
              onChange={handleChange}
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <input
              type="text"
              name="businessName"
              placeholder="business name (optional)"
              value={formData.businessName}
              onChange={handleChange}
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <input
              type="text"
              name="businessAddress"
              placeholder="business address or country (optional)"
              value={formData.businessAddress}
              onChange={handleChange}
              className="w-full px-4 py-4 sm:py-5 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400"
            />

            <textarea
              name="message"
              placeholder="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="w-full px-4 py-10 sm:py-12 rounded-[20px] bg-[#F0F0F0] focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
            ></textarea>

            {error && (
              <p className="text-red-500 text-sm font-poppins">{error}</p>
            )}

            <span className="mt-0 flex justify-center sm:mr-[40px] ml-0 items-start float-right">
              <GlowButton btnValue={loading ? "sending..." : "get a solution"} btn1="2" />
            </span>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactContent;
